import { render, staticRenderFns } from "./reason-reject.vue?vue&type=template&id=38d65814&"
import script from "./reason-reject.vue?vue&type=script&lang=js&"
export * from "./reason-reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports